function DamagePolicy() {
  return (
    <div style={styles.container}>
      <h1>🛠 Bike Damage & Condition Policy</h1>

      <div style={styles.card}>
        <h2>🚲 Bike Condition at Pickup</h2>
        <ul>
          <li>Bike is provided in good working condition</li>
          <li>Minor scratches may already exist</li>
          <li>Please inspect the bike before leaving the shop</li>
          <li>Report any existing damage immediately</li>
        </ul>

        <h2>⚠️ Rider Responsibility</h2>
        <ul>
          <li>Rider is responsible for bike safety during rental</li>
          <li>Always lock the bike when parked</li>
          <li>No reckless or off-road riding</li>
        </ul>

        <h2>💥 Damage Charges</h2>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Damage Type</th>
              <th>Charge</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Minor scratch</td>
              <td>₹300 – ₹500</td>
            </tr>
            <tr>
              <td>Mirror / Indicator</td>
              <td>₹800 – ₹1500</td>
            </tr>
            <tr>
              <td>Major body damage</td>
              <td>As per service cost</td>
            </tr>
            <tr>
              <td>Accident / Frame damage</td>
              <td>Full repair cost</td>
            </tr>
          </tbody>
        </table>

        <h2>🧾 Insurance & Theft</h2>
        <ul>
          <li>Bikes are not insured for customer negligence</li>
          <li>Theft must be reported to police immediately</li>
          <li>Customer bears full cost in case of theft</li>
        </ul>

        <h2>📞 In Case of Emergency</h2>
        <p>
          Contact our support immediately via WhatsApp or call.
          Delayed reporting may increase liability.
        </p>

        <div style={styles.note}>
          <strong>Note:</strong> Riding under the influence of alcohol or drugs
          will result in full liability for damages.
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "auto",
    paddingTop: "90px",
  },
  card: {
    background: "#f9f9f9",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    marginBottom: "20px",
  },
  note: {
    marginTop: "15px",
    padding: "12px",
    background: "#fff3cd",
    borderRadius: "6px",
    color: "#856404",
  },
};

export default DamagePolicy;
